import m from "../../geodata/es2015/zimbabweHigh";
window.am4geodata_zimbabweHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/zimbabweHigh.js
// module id = null
// module chunks = 